<template>
    <section>
        <v-flex style="margin: 15px 55px;">
             <v-data-table :headers="headers" 
                           :items="Results" 
                           hide-actions
                           class="elevation-1" 
                           style="margin-bottom: 10px;"
                           disable-initial-sort
                           :loading='loading' 
                           loading-text="Loading... Please wait">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Company_Name }}</td>
                        <td class="text-xs-center">{{ props.item.Title }}</td>
                        <td class="text-xs-center">{{ `https://prwatech.com/result?query=${props.item.Company_Name}_${props.item.Title}_${props.item.Unique_Id}`}}</td>
                        <td class="text-xs-center">{{ new Date(props.item.Created_On).toLocaleDateString() }}</td>
                        <td class="text-xs-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="primary" class="clsForActions" @click="OpenDialog(props.item)" dark v-on="on">visibility</v-icon>
                                </template>
                                <span>View</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetDataFromDB"></pagination>
        </v-flex>
        <result-upload ref='ViewDetails' :dialog='ResultDetailsDialog' @close='CloseDialog'></result-upload>
    </section>
</template>

<script>
import ResultUpload from '../dialogs/ResultUpload'
export default {
    components:{
        ResultUpload
    },
    data(){

        return {

            headers                     : [ { text: 'Company_Name',value: 'Company_Name' },
                                            { text: 'Title' , value : 'Title'},
                                            { text: 'URL' },
                                            { text: 'Created_On' , value : 'Created_On'},
                                            { text: ' ' } ],
            Results                     : [],
            pages                       : 1,
            records                     : 0,
            ResultDetailsDialog         : false,
            loading                     : false,

        }
    },
    methods:{
        CloseDialog(){
            this.ResultDetailsDialog = false
        },
        OpenDialog(item){
            this.$refs.ViewDetails.FetchCompanyList()
            this.$refs.ViewDetails.DisplayDetails(item)
            this.ResultDetailsDialog = true
        },
        GetDataFromDB(){ 
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/resultupload/getresultlist`,{ limit:10, page : this.pages })
                        .then(response =>{
                            
                            this.Results = response["data"]["response"]
                            this.records = response["data"]["Records"]
                            this.loading = false
        
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        }
    },
    mounted(){
        this.GetDataFromDB()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>